<div class="tasks-list--container">
    <div class="aggregate-card--container-header">
        <forge-toolbar no-border>
            <h2 slot="start" class="forge-typography--heading4">{{header}}</h2>
            <busy-indicator slot="center" *ngIf="!loaded"></busy-indicator>
            <forge-icon-button slot="end" (click)="displayOrdering()" tabindex="0" aria-haspopup="true" aria-label="Smart Card settings"
                            telemetry="Smart Card settings">
                <forge-tooltip>Smart Card settings</forge-tooltip>
                <forge-icon name="settings"></forge-icon>
            </forge-icon-button>
        </forge-toolbar>
    </div>

    <div *ngIf="showNoTasksMsg">
        <span class="forge-typography--body1">No smart cards to review</span>
    </div>

    <div *ngIf="loaded">
        <div>
            <forge-accordion panel-selector="forge-expansion-panel">
                <aggregate-collection [aggregateCriterias]="aggregateCriterias">
                </aggregate-collection>
            </forge-accordion>
        </div>
    </div>
</div>
